// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".es-create-button--simple[data-v-b38d93ca]{background:none;border:none;height:36px;cursor:pointer;margin-left:10px}.es-create-button--simple[data-v-b38d93ca]:hover{background:var(--color-brand-50)}.es-create-button--simple:hover svg[data-v-b38d93ca]{opacity:.5}.es-create-button--simple svg[data-v-b38d93ca]{opacity:1;height:20px;width:20px;fill:var(--color-brand-700)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
